import AppHeader from "@/layout/AppHeader";
import WapHeader from "@/layout/wapHeaderNew";
import AppDetailHeader from "@/layout/AppDetailHeader";
import AppFooter from "@/layout/AppFooter";
import ImportNews from "@/page/importNews/index";

// import Main from '@/layout/Main'
// import Home from '@/page/index'
// import Community from '@/page/community/index'
import Column from "@/page/column/index";
// import iNewsList from '@/page/iNewsList/index'
// import importNewsDetail from '@/page/importNewsDetail/index'
// import UserProfiles from '@/page/Profiles/index'

//以后统一一下，跟活动或者是app内嵌相关的 都带上 /up/
//其他不要带 /up/  这里有一个域名跳转规则！！！！


export default [
  {
    path: "/",
    redirect: "/up/iNewsList",
  },
  // 首页最新样式
  {
    path: "/home",
    meta: {
      title: "爱股票",
    },
    components: {
      default: () => import("@/page/home/index"),
    },
  },

  //模拟炒股大赛 站外分享

  {
    path: "/up/simulatedStock/tradingContest",
    meta: {
      title: "参与模拟炒股大赛，赢万元现金大奖！",
    },
    components: {
      default: () => import("@/page/activity/simulatedStock/index"),
    },
  },


  // {
  //     path: '/express/lists',
  //     name: 'Home',
  //     meta: {
  //         title: '首页',
  //     },
  //     components: {
  //         header: AppHeader,
  //         default: Home,
  //         footer: AppFooter
  //     }
  // },
  // {
  //     path: '/up/community',
  //     name: 'Community',
  //     meta: {
  //         title: '社区',
  //     },
  //     components: {
  //         header: AppHeader,
  //         default: Community,
  //         footer: AppFooter
  //     }
  // },
  {
    path: "/up/column",
    name: "Column",
    meta: {
      title: "专栏",
    },
    components: {
      header: AppHeader,
      default: Column,
      footer: AppFooter,
    },
  },
  {
    path: "/up/spread",
    name: "Spread",
    meta: {},
    components: {
      default: () => import("@/page/home/spread"),
    },
  },
  {
    path: "/up/download",
    name: "Spread",
    meta: {},
    components: {
      default: () => import("@/page/home/download"),
    },
  },
  {
    path: "/express/expresslist",
    name: "ImportNews",
    meta: {
      title: "资讯",
    },
    components: {
      header: AppHeader,
      default: ImportNews,
      footer: AppFooter,
    },
  },
  // 老师页面
  {
    path: "/lives/center/id/:id",
    name: "TeacherProfiles",
    meta: {
      title: "个人主页",
    },
    components: {
      //header: AppHeader,
      default: () => import("@/page/appProfiles/index"),
      //有两种 appProfiles Profiles
      //footer: AppFooter,
    },
  },
  {
    path: "/lives/center/id/:id/*",
    name: "TeacherProfiles",
    meta: {
      title: "个人主页",
    },
    components: {
      //header: AppHeader,
      default: () => import("@/page/appProfiles/index"),
      //footer: AppFooter,
    },
  },
  // 用户页面
  {
    path: "/ucenter/user_home/m_u_id/:id",
    name: "UserProfiles",
    meta: {
      title: "个人主页",
    },
    components: {
      //header: AppHeader,
      default: () => import("@/page/appProfiles/index"),
      //有两种 appProfiles Profiles
      footer: AppFooter,
    },
  },

  {
    path: "/app_lives/center/id/:id/*",
    name: "TeacherProfiles",
    meta: {
      title: "个人主页",
    },
    components: {
      // header: AppHeader,
      default: () => import("@/page/appProfiles/index"),
      // footer: AppFooter
    },
  },
  {
    path: "/app_lives/center/id/:id",
    name: "TeacherProfiles",
    meta: {
      title: "个人主页",
    },
    components: {
      // header: AppHeader,
      default: () => import("@/page/appProfiles/index"),
      // footer: AppFooter
    },
  },
  // 用户页面
  {
    path: "/app_ucenter/user_home/m_u_id/:id",
    name: "UserProfiles",
    meta: {
      title: "个人主页",
    },
    components: {
      // header: AppHeader,
      default: () => import("@/page/appProfiles/index"),
      // footer: AppFooter
    },
  },

  // {
  //     path: '/ucenter/index/rd/:id',
  //     name: 'UserProfiles',
  //     meta: {
  //         title: '个人主页',
  //     },
  //     components: {
  //         header: AppHeader,
  //         default: () => import('@/page/Profiles/index'),
  //         footer: AppFooter
  //     }
  // },
  {
    path: "/ucenter/index",
    name: "ucenter",
    meta: {
      title: "个人中心",
    },
    components: {
      header: WapHeader, // AppHeader
      default: () => import("@/page/ucenter/index"),
      // footer: AppFooter,
    }, 
  },
  {
    path: "/up/mybuy",
    name: "my-buy",
    meta: {
      title: "我的购买",
    },
    components: {
      header: WapHeader, // AppHeader
      default: () => import("@/page/ucenter/my_buy"),
      // footer: AppFooter,
    }, 
  },
  //消息页面
	{
		path: "/message",
		name: "Message",
		meta: {
			title: "消息",
			notKeepAlive: false
		},
		component: () => import("@/page/message/message.vue")
	},
	//消息页面
	{
		path: "/up/mes/:id",
		name: "Mes",
		meta: {
			title: "消息"
		},
    components: {
      header: WapHeader, // AppHeader
      default: () => import("@/page/message/mes.vue"),
      // footer: AppFooter,
    }, 
		// component: () => import("")
	},
  {
    path: "/up/chattingRoom/:chat_room_live_id",
    name: "chattingRome",
    meta: {
      title: "聊天室"
    },
    components: {
      default: ()=> import("@/page/appProfiles/TabsChattingRoom.vue")
    }
  },
  {
    path: "/up/chattingRoom/:chat_room_live_id/:userId/:userNick",
    meta: {
        title: ''
    },
    name: "chattingRoomForUser",
    components: {
      default: ()=> import("@/page/appProfiles/chattingRoomForUser.vue")
    }
  },
  {
    path: "/up/app/chattingRoom/:chat_room_live_id",
    name: "聊天室",
    meta: {
      title: "聊天室"
    },
    components: {
      default: ()=> import("@/page/app/chatting_room.vue")
    }
  },
  {
    path: "/up/app/chattingRoom/:chat_room_live_id/:userId/:userNick",
    meta: {
        title: ''
    },
    name: "chattingRoomForUser",
    components: {
      default: ()=> import("@/page/app/chatting_room_for_user.vue")
    }
  },
  {
    path: "/up/iNewsList",
    name: "iNewsList",
    meta: {
      title: "资讯列表",
      notKeepAlive: true,
    },
    components: {
      header: AppDetailHeader,
      default: () => import("@/page/iNewsList/index"),
      footer: AppFooter,
    },
  },
  {
    path: "/up/importNewsDetail/:id",
    name: "importNewsDetail",
    meta: {
      title: "资讯详情",
    },
    components: {
      default: () => import("@/page/importNewsDetail/index"),
    },
  },
  // https://mobilebeta.aigupiao.com/up/inviteCashBack?access_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9hcGliZXRhLmFpZ3VwaWFvLmNvbVwvdjFcL2FjY2Vzc1wvdG9rZW4iLCJpYXQiOjE2NDI0Njg2OTIsImV4cCI6MTY1ODAyMDY5MiwibmJmIjoxNjQyNDY4NjkyLCJqdGkiOiJ1RGthWUdjZEVKaHFMTXBBIiwic3ViIjo0NDMyNCwicHJ2IjoiNTc5NmQ4MDZiNGViMGNmNDk5NzkxMzFjMmI5ZTliNmMwMjIwYTU5OSJ9.uet_ekHlGw1GB9r_mbxToXXRmQmf4gYDxRW0fj6WhO4&user_id=44324&jump_source=comm_inviteappversion=9.2.0
  {
    path: "/up/inviteCashBack",
    name: "inviteCashBack",
    meta: {
      title: "邀请有奖",
    },
    components: {
      default: () => import("@/page/activity/inviteCashBack/index"),
    },
  },
  {
    path: "/up/inviteRecords/:userID/:token",
    name: "inviteRecords",
    meta: {
      title: "好友邀请详情",
    },
    components: {
      default: () => import("@/page/activity/inviteCashBack/inviteRecords"),
    },
  },
  // 
  {
    path: "/up/index_futures_share/share_id/:encryption",
    name: "inviteCashBackShare",
    meta: {
      title: "送你爱股票新人红包",
    },
    components: {
      default: () => import("@/page/activity/inviteCashBack/wxShare"),
    },
  },
  //h5分享的股指期货页面  ： 服务器端默认路径有/up
  {
    path: "/up/stock_index_futures",
    name: "Stock_index_futures",
    meta: {
      title: "股指期货-行情-爱股票",
    },
    components: {
      default: () => import("@/page/Stock_index_futures/index"),
      footer: AppFooter,
    },
  },
  // test nav
  {
    path: "/up/fedemo",
    meta: {
      title: "导航",
    },
    components: {
      default: () => import("@/page/test/index"),
    },
  },
  // 已购买详细页
  {
    path: "/up/Intelligent_diagnosis_stock/symbol/:id/uid/:uid/name/:name/*",
    name: "Intelligent_diagnosis_stock_detail",
    meta: {
      title: "智能诊股",
    },
    components: {
      default: () => import("@/page/Intelligent_diagnosis_stock/detail"),
    },
  },
  //智能诊股 首页
  {
    path: "/up/Intelligent_diagnosis_stock*",
    name: "Intelligent_diagnosis_stock_index",
    meta: {
      title: "智能诊股",
    },
    components: {
      default: () => import("@/page/Intelligent_diagnosis_stock/index"),
    },
  },
  //智能诊股 未购买
  {
    path: "/up/Intelligent_diagnosis_stock/notBuy",
    name: "Intelligent_diagnosis_stock_notBuy",
    meta: {
      title: "智能诊股",
    },
    components: {
      default: () => import("@/page/Intelligent_diagnosis_stock/notBuy"),
    },
  },

  //pdf查看
  {
    path: "/up/pdf/:url/:name",
    name: "pdf",
    component: () => import("@/page/pdf/index.vue"),
  },
  // 榜单 app内嵌
  {
    path: "/up/tops",
    component: () => import("@/page/tops/index.vue"),
    meta: {
      title: "排行榜",
    },
  },
  // 旧版本使用新功能时引导升级 app内嵌
  {
    path: "/up/upgrade",
    component: () => import("@/page/upgrade/index.vue"),
    meta: {
      title: "新版本下载提示",
    },
  },
  //雷爆了合作 页面：基本面选股
  {
      path: "/up/leibaole/notBuy",
      component: () => import("@/page/leibaole/notBuy"),
      meta: {
          title: "基本面选股",
      },
  },
  // 模拟炒股大赛详情页
  {
    path: "/up/HsReplicaProfits/m_u_id/:m_u_id/match_id/:match_id",
    name: "HsReplicaProfits",
    meta: {
      title: "爱股票模拟炒股大赛",
    },
    components: {
      default: () => import("@/page/hsReplicaProfits/index"),
      // footer: AppFooter,
    },
  },
  // 模拟炒股详情页
  {
    path: "/up/HsReplicaProfits",
    name: "HsReplicaProfits",
    meta: {
      title: "爱股票投资组合",
    },
    components: {
      default: () => import("@/page/hsReplicaProfits/index"),
      // footer: AppFooter,
    },
  },
  // 文件下载
  {
    path: "/up/file/:url/:name/:type", // /:size
    name: "file",
    component: () => import("@/page/file/index.vue")
  },
  // 文件下载
  {
    path: "/up/file/:url/:name/:type/:size", // 
    name: "file",
    component: () => import("@/page/file/index_size.vue")
  },
  {
    path: "/up/stockPool",
    name: "stockPool",
    component:() => import("@/page/stockPool/index.vue")
  },
  {
    path: "/up/h5/stockPool",
    name: "stockPool",
    component:() => import("@/page/stockPool/index.vue")
  },
  {
    path: "/up/msg_report",
    name: "msg_report",
    meta: {
      title: "举报",
    },
    component:() => import("@/page/msg_report/index.vue")
  },
  {
    path: "/up/ai/:id",
    name: "爱股票AI",
    meta: {
      title: "爱股票AI",
    },
    component:() => import("@/page/ai/index.vue")
  },
  //app下面的资料标签内嵌  股票code；深色还是浅色模式
  // http://192.168.1.59:8080/up/information/sz000070/light
  {
    path: "/up/information/:code/:mode",
    name: "资料",
    meta: {
      title: "资料",
    },
    component:() => import("@/page/information/index.vue")
  },
  {
    path: "/up/app_down",
    name: "下载爱股票App",
    meta: {
      title: "下载爱股票App",
    },
    components: {
      default: () => import("@/page/appDown/index.vue")
    },
  },
  {
    path: "/up/nickName",
    name: "【爱股票平台关于用户昵称的禁止性规定】",
    meta: {
      title: "【爱股票平台关于用户昵称的禁止性规定】",
    },
    components: {
      default: () => import("@/page/nickName/index.vue")
    },
  },
  {
    path: "/up/app/advHomePage",
    name: " ",
    meta: {
      title: " "
    },
    component:() => import("@/page/app/user_home.vue")
  },
  {
    path: "/up/app/advLiveMsg",
    name: "会员区",
    meta: {
      title: "会员区",
    },
    components: {
      // header: () => import("@/layout/zxHeader"),
	    default: () => import("@/page/app/free_detail.vue")
    },
  },
  {
    path: "/up/app/advLiveMsg2",
    name: "详情页",
    meta: {
      title: "详情页",
    },
    components: {
	    default: () => import("@/page/app/detail.vue")
    },
  },
  // jf
  {
    path: "/up/app/advJFHomePage",
    name: "爱股票",
    meta: {
      title: "爱股票"
    },
    component:() => import("@/page/app/jf_user_home.vue")
  },
  {
    path: "/up/app/advJFLiveMsg",
    name: "会员区",
    meta: {
      title: "会员区",
    },
    components: {
      // header: () => import("@/layout/zxHeader"),
	    default: () => import("@/page/app/jf_detail.vue")
    },
  },
  //jf wap 相关登录页面
  {
    path: "/up/jf_login",
    name: "登录",
    meta: {
      title: "登录",
    },
    components: {
	    default: () => import("@/page/jf_login.vue")
    },
  },


  // jf
  {
    path: "/up/app/gold_detail",
    name: "金币明细",
    meta: {
      title: "金币明细",
    },
    components: {
      header: () => import("@/layout/zxHeader"),
      default: () => import("@/page/gold/detail.vue")
    },
  },
  {
    path: "/up/app/account",
    name: "账户钱包",
    meta: {
      title: "账户钱包",
    },
    components: {
      header: () => import("@/layout/zxHeader"),
      default: () => import("@/page/gold/index.vue")
    },
  },
  {
    path: "/up/app/agreement",
    name: "用户签订协议",
    meta: {
      title: "用户签订协议",
    },
    components: {
      //header: () => import("@/layout/zxHeader"),
      default: () => import("@/page/gold/agreement.vue")
    },
  },
  {
    path: "/up/app/agreement_detail",
    name: "爱股票-会员产品",
    meta: {
      title: "用户签订协议",
    },
    components: {
      //header: () => import("@/layout/zxHeader"),
      default: () => import("@/page/gold/agreement_detail.vue")
    },
  },
  {
    path: "/up/app/vip_product",
    name: "会员产品",
    meta: {
      title: "会员产品",
    },
    components: {
      header: () => import("@/layout/zxHeader"),
      default: () => import("@/page/gold/vip_product.vue")
    },
  },
  {
    path: "/up/app/vip_product/wap",
    name: "爱股票-会员产品",
    meta: {
      title: "购买会员",
    },
    components: {
      default: () => import("@/page/gold/vip_product.vue")
    },
  },
  {
    path: "/up/app/vip_agreement",
    name: "爱股票-会员产品",
    meta: {
      title: "填写会员协议（必填）",
    },
    components: {
      default: () => import("@/page/gold/vip_agreement.vue")
    },
  },
  {
    //已购买未签约需要跳转到这里
    path: "/up/app/pay_succ",
    name: "爱股票-会员产品",
    meta: {
      title: "成功开通会员",
    },
    components: {
      default: () => import("@/page/gold/pay_succ.vue")
    },
  },
  {
    path: "/up/app/signAgreement",
    name: "爱股票-会员产品",
    meta: {
      title: "用户签名",
    },
    components: {
      default: () => import("@/page/gold/signAgreement.vue")
    },
  },
  {
    path: "/up/introduction",
    name: "爱股票",
    meta: {
      title: "爱股票",
    },
    components: {
      default: () => import("@/page/introduction/index.vue")
    },
  },
  {
    path: "/up/app/vip_loading",
    meta: {
      title: "即将进入投顾公司页面",
    },
    components: {
      default: () => import("@/page/app/page_loading.vue")
    },
  },
  {
    path: "/up/handbook",
    name: "新人手册",
    meta: {
      title: "新人手册",
    },
    components: {
      default: () => import("@/page/handbook/index.vue")
    },
  },
  {
    path: "/up/xiaoai",
    name: "小爱老师人工智能服务使用条款",
    meta: {
      title: "小爱老师人工智能服务使用条款",
    },
    components: {
      default: () => import("@/page/xiaoai.vue")
    },
  },
  {
    path: "/up/guidelines",
    name: "爱股票账号管理规范",
    meta: {
      title: "爱股票账号管理规范",
    },
    components: {
      default: () => import("@/page/guidelines2.vue")
    },
  },
  {
    path: "/up/collaborator/application",
    name: "入驻合作申请",
    meta: {
      title: "入驻合作申请",
    },
    components: {
      default: () => import("@/page/collaborator/application.vue")
    },
  },
  {
      path: "/up/information_invest",
      name: "information",
      meta: {
          title: "投资者基本信息表"
      },
      component: () => import("@/page/information_invest/index.vue")
  },
  {
    path: "/up/collaborator/agree",
    name: "爱股票合作者服务规范",
    meta: {
      title: "爱股票合作者服务规范",
    },
    components: {
      default: () => import("@/page/collaborator/agree.vue")
    },
  },

  {
    path: "/up/app/comment",
    name: "评论组件测试",
    meta: {
      title: "评论组件测试",
    },
    components: {
      default: () => import("@/page/app/comment.vue")
    },
  },
  {
    path: "/up/app/loading",
    name: "爱股票",
    meta: {
      title: "爱股票"
    },
    components: {
      default: () => import("@/page/app/loading.vue"),
    }
  },
  {
    path: "/up/app/memberArea",
    name: "memberArea",
    meta: {
      title: "投顾会员专区"
    },
    components: {
      default: () => import("@/page/app/member_area.vue"),
    }
  }
//以后统一一下，跟活动或者是app内嵌相关的 都带上 /up/
//其他不要带 /up/  这里有一个域名跳转规则！！！！
//投顾相关的 /up/app/

];
